import React from 'react';
import cn from 'classnames';
import {
  BarChart,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  Bar,
  Label,
  ReferenceLine,
} from 'recharts';
import { maxPrice, minPrice } from './Context';
import { maxMinData } from './ChartDataInfo';
import type { CompanyValueData } from './ChartLine';
import type { WindowSize } from './GraphHeader';

interface Props {
  className?: string;
  data: Array<CompanyValueData>;
  YValue: string;
  windowSize: WindowSize;
}

const HistoChartGraph: React.FC<Props> = React.memo(
  ({ className, data, YValue, windowSize }) => {
    const max: maxMinData = maxPrice(data);
    const min: maxMinData = minPrice(data);

    return (
      <div className={cn(className)}>
        <BarChart
          width={
            windowSize.width === 1000
              ? windowSize.width - 25
              : windowSize.width - 50
          }
          height={windowSize.width > 1000 ? 300 : 220}
          data={data}
          margin={{ top: 5, right: 10, left: -20, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis fontSize={10} tickSize={2} dataKey="date">
            <Label value="date" fontSize={12} position="insideBottom" />
          </XAxis>
          <YAxis
            fontSize={10}
            tickSize={2}
            domain={[min[0] - min[0] * 0.15, max[0] + max[0] * 0.05]}
          />
          <ReferenceLine x={min[1]} stroke="#c1d1fc" label={`${min[0]}`} />
          <ReferenceLine x={max[1]} stroke="#ffc5c5" label={`${max[0]}`} />
          <Legend />
          <Tooltip />
          <Bar type="monotone" dataKey={YValue} fill="#8b85ff" />
        </BarChart>
      </div>
    );
  },
);

export default HistoChartGraph;
